'use strict';

var PeerInfo = require('peer-info');

var PeerId = require('peer-id');

var multiaddr = require('multiaddr');

var pull = require('pull-stream');

var lp = require('pull-length-prefixed');

var msg = require('./message');

module.exports = function (conn, expectedPeerInfo, callback) {
  if (typeof expectedPeerInfo === 'function') {
    callback = expectedPeerInfo;
    expectedPeerInfo = null;
    console.warn('WARNING: no expected peer info was given, identify will not be able to verify peer integrity');
  }

  pull(conn, lp.decode(), pull.take(1), pull.collect(function (err, data) {
    if (err) {
      return callback(err);
    } // connection got closed graciously


    if (data.length === 0) {
      return callback(new Error('conn was closed, did not receive data'));
    }

    var input = msg.decode(data[0]);
    PeerId.createFromPubKey(input.publicKey, function (err, id) {
      if (err) {
        return callback(err);
      }

      var peerInfo = new PeerInfo(id);

      if (expectedPeerInfo && expectedPeerInfo.id.toB58String() !== id.toB58String()) {
        return callback(new Error('invalid peer'));
      }

      try {
        input.listenAddrs.map(multiaddr).forEach(function (ma) {
          return peerInfo.multiaddrs.add(ma);
        });
      } catch (err) {
        return callback(err);
      }

      var observedAddr;

      try {
        observedAddr = getObservedAddrs(input);
      } catch (err) {
        return callback(err);
      }

      callback(null, peerInfo, observedAddr);
    });
  }));
};

function getObservedAddrs(input) {
  if (!hasObservedAddr(input)) {
    return [];
  }

  var addrs = input.observedAddr;

  if (!Array.isArray(addrs)) {
    addrs = [addrs];
  }

  return addrs.map(function (oa) {
    return multiaddr(oa);
  });
}

function hasObservedAddr(input) {
  return input.observedAddr && input.observedAddr.length > 0;
}